import { render } from "./CloudtecGym.vue?vue&type=template&id=67d23cdf&scoped=true"
import script from "./CloudtecGym.vue?vue&type=script&lang=js"
export * from "./CloudtecGym.vue?vue&type=script&lang=js"

import "./CloudtecGym.vue?vue&type=style&index=0&id=67d23cdf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d23cdf"]])

export default __exports__